import sendInitialAppEvents from './initialize/sendInitialAppEvents';
import { sendLoginStateEvents } from './initialize/loginState';
import sendPointOfNeedAppEvent from './initialize/sendPointOfNeedAppEvent';
export function getLastResponseExtensionData(responses) {
    if (responses.length) {
        return responses[responses.length - 1].extensionData;
    }
    return undefined;
}
function setHistory(appEventResponses, curHistory, isLoggedOut) {
    const newResponseCount = appEventResponses.length;
    if (newResponseCount === 0) {
        return curHistory;
    }
    if (isLoggedOut) {
        return appEventResponses;
    }
    else {
        curHistory.push(...appEventResponses);
        return curHistory;
    }
}
export default async function initializeAppEvents(almeState, setAlmeState, appConfig, isAppEventsSent, almeApiUtils) {
    /**
     * Only send app events when IVA is open and history is loaded
     */
    if (!almeState.isOpen || !almeState.historyLoaded) {
        return;
    }
    isAppEventsSent.current = true;
    let appEventResponses = [];
    /**
    * Send HostPageData and  WelcomeUser appevents only when there is no previous conversation
    */
    if (!almeState.hasPreviousConversation) {
        appEventResponses = await sendInitialAppEvents(almeApiUtils, almeState);
    }
    if (!almeState.isLoggedIn && almeState.isLiveChatConnected) {
        setAlmeState(Object.assign(Object.assign({}, almeState), { isInitialAppEventsSent: true, lastActivityTime: Date.now() }));
        return;
    }
    /**
    * Verify and send login appevents every time IVA is launched (Page refresh or manual launch by user)
    */
    const loggedInState = await sendLoginStateEvents(appConfig, almeApiUtils, almeState);
    if (loggedInState.loginStateResponse) {
        appEventResponses.push(loggedInState.loginStateResponse);
    }
    const extensionData = getLastResponseExtensionData(appEventResponses);
    const state = Object.assign(Object.assign({}, almeState), { isLoggedIn: loggedInState.isLoggedIn, clientSessionId: loggedInState.clientSessionId, 
        // On logout don't add previous history
        history: setHistory(appEventResponses, almeState.history, !!(!loggedInState.isLoggedIn && loggedInState.loginStateResponse)), lastEntryId: (extensionData && extensionData.entryId) || almeState.lastEntryId, chatId: (extensionData && extensionData.chatId) || almeState.chatId, lastActivityTime: appEventResponses.length >= 1 ? Date.now() : almeState.lastActivityTime, isLiveChatConnected: loggedInState.isLiveChatConnected, isInitialAppEventsSent: true });
    setAlmeState(state);
    /**
    * Send point of need appevent only when there is no previous conversation
    */
    const pointOfNeedResponse = await sendPointOfNeedAppEvent(almeApiUtils, state);
    if (pointOfNeedResponse) {
        state.history.push(pointOfNeedResponse);
        setAlmeState(Object.assign(Object.assign({}, state), { lastEntryId: pointOfNeedResponse.extensionData.entryId, chatId: pointOfNeedResponse.extensionData.chatId, launchPointName: undefined, launchParameter: undefined, lastActivityTime: Date.now() }));
    }
}
